<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <h1>网络异常</h1>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page class-edit">
      <div class="wifiless text-center">
        <div class="wifi-wrap">
          <p class="font-14 padding-15">啊哦，网络不太顺畅哦~</p>
          <span class="button button-rounded button-primary font-14" style="padding:0 30px;width:60px;height:40px;line-height:40px;margin:0 auto;" @click="checkNetwork">重新加载</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Indicator } from 'mint-ui'
  import { serviceCheckNetwork } from '../service'

  export default {
    data () {
      return {
      }
    },
    readay: function () {
    },
    methods: {
      checkNetwork: () => {
        Indicator.open()
        $.ajax({
          type: 'get',
          url: serviceCheckNetwork + '?date=' + new Date().getTime(),
          success: () => {
            Indicator.close()
            window.history.go(-1)
          },
          error: () => {
            Indicator.close()
          }
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// networkLess.vue?1af73dbd